import React from 'react';
import { FormattedMessage } from 'react-intl';

import { AdminSlot } from 'modules/kiosk/types/Slot';
import Button, { ButtonType } from 'components/ui/Button';

import SlotCamera from '../../SlotCamera';

const EmergencyKeysManagementModalContent: React.FC<AdminSlot & { onClose: () => void }> = ({
  referenceId,
  position,
  registration,
  displayName,
  onClose,
  rack,
}) => {
  const information = [referenceId, displayName].filter(Boolean).join(' - ');

  return (
    <>
      <h1 className="mt-16 text-center">
        <FormattedMessage
          id="admin.manage.key.slotLabel"
          defaultMessage="Slot N°{number}"
          values={{ number: position }}
        />
      </h1>
      <h1 className="mt-4">{registration}</h1>
      <div className="text-3xl mt-4">{information}</div>
      <h1 className="mt-16 max-w-3xl text-6xl text-center !leading-normal" data-testid="key-question">
        <FormattedMessage id="admin.manage.key.question.emptySlot" defaultMessage="Empty the slot before confirming" />
      </h1>
      <SlotCamera rack={rack} className="my-10" hideHint />
      <div className="my-16 bg-white rounded-admin-card p-10">
        <Button className="min-w-18" type={ButtonType.ERROR} onClick={onClose} testId="key-confirm-btn">
          <FormattedMessage id="confirm.title" defaultMessage="Confirm" />
        </Button>
      </div>
    </>
  );
};

export default EmergencyKeysManagementModalContent;
